module.exports = __webpack_public_path__ + "img/xrp-the-asset.29401f14.png";